<template>
	<div class="h-crumbOut">
		<div class="h-crumbs">
			<el-breadcrumb separator="|">
				<el-breadcrumb-item v-if="flag">今日待办</el-breadcrumb-item>
				<el-breadcrumb-item v-if="!flag"><a @click="toIndex">我的工作台</a></el-breadcrumb-item>
				<el-breadcrumb-item v-for="(item,i) in routerList" :key="i" :to="{ path: item.to }">{{item.title}}</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
	</div>
</template>

<script>
	export default {
		name:"breadcrumb",
		props:["routerList","flag"],
		methods:{
            toIndex(){
                var defaultpage = this.$store.getters.user.defaultpage
                this.$router.push({path: defaultpage});
			}
		}
	}
</script>

<style scoped>
	.innerclass{
		margin: 0 auto;
	}
</style>
<style>
	.breadcrumb{
		position: absolute;
		top: 11px;
		left: 15px;
	}
	.breadcrumb .el-breadcrumb__inner a, .el-breadcrumb__inner.is-link{
		color: #adadad;
	}
	.breadcrumb .el-breadcrumb__inner a, .el-breadcrumb__inner.is-link{
		color: #0056a4!important;
	}
	.el-breadcrumb__separator{
		transform: rotate(90deg);
	}
</style>
